// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2z8cU","itemTitle":"ClientEmergencyInfo_itemTitle__2VEo3","itemText":"ClientEmergencyInfo_itemText__VWLZg"};